import React, { useEffect, useState } from "react";
import {
  Button,
  TextField,
  MenuItem,
  Typography,
  Box,
  Grid,
  Tooltip,
  Card,
  CardContent,
  IconButton,
  Menu,
  List,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DeleteIcon from "@mui/icons-material/Delete";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { grey } from "@mui/material/colors";
import {
  GetOfferLetterTemplateAction,
} from "../../../../../store/ATS/FormTemplate/Action";
import { useDispatch, useSelector } from "react-redux";
import {
  AddOfferLetterTemplateHelper,
  UpdateOfferLetterTemplateHelper,
} from "../../helper/AtsFormTemplateHelper";
import { parseOfferLetterContent } from "./editor/OfferLetterDocumentEditor";

function Prompt({ setCurrentMode, activeStep, setActiveStep, data, setData, letterHeadData, companylogo, isStepLoading, setIsStepLoading }) {
  const dispatch = useDispatch();
  const { letterHeadData: reduxLetterHead } = useSelector((state) => state?.AncillaryReducer?.LetterHeadReducer || {});
  const currentLetterHead = letterHeadData || reduxLetterHead?.[0];

  const [loading, setLoading] = useState(false);

  const updateLoading = (val) => {
    setLoading(val);
    if (setIsStepLoading) setIsStepLoading(val);
  };

  const defaultFixedFields = [
    { id: "candidate_name", name: "candidate_name", label: "Candidate Name", type: "text", required: true, disable: true },
    { id: "ctc", name: "ctc", label: "CTC", type: "text", required: false, disable: true },
    { id: "ctc_in_words", name: "ctc_in_words", label: "CTC in Words", type: "text", required: false, disable: true },
    { id: "offer_letter_no", name: "offer_letter_no", label: "Offer Letter No", type: "text", required: false, disable: true },
    { id: "date", name: "date", label: "Date", type: "date", required: true, disable: false },
    { id: "designation", name: "designation", label: "Designation", type: "text", required: true, disable: false },
    { id: "joiningdate", name: "joiningdate", label: "Join Date", type: "date", required: true, disable: false },
  ];
  const [formFields, setFormFields] = useState(defaultFixedFields);
  const [formComponents, setFormComponents] = useState([]);
  const [formHeading, setFormHeading] = useState({ heading: "" });
  const [offerletter, setOfferLetter] = useState({
    access_company_logo: false,
    access_footer: false,
    access_header: false,
    company_logo: "",
    footer: "",
    header: "",
  });
  const [menu, setMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    dispatch(GetOfferLetterTemplateAction());
    const parsed = parseOfferLetterContent(data?.offer_letter_content);
    const activeMode = data?.header_footer_mode || parsed?.header_footer_mode || "OUR_HEADER_FOOTER";
    if (data?.offer_letter_template_id) {
      setFormHeading({ heading: data?.offer_letter_template_name });
      const rawFields = Array.isArray(data?.offer_letter_template_fields) ? [...data.offer_letter_template_fields] : [];
      const topFields = defaultFixedFields.map((fixed) => {
        const found = rawFields.find((f) => f.name === fixed.name || f.label?.toLowerCase() === fixed.label?.toLowerCase());
        return {
          ...fixed,
          ...(found || {}),
          id: fixed.id || fixed.name,
          name: fixed.name,
          label: found?.label || fixed.label,
          type: found?.type || fixed.type,
          disable: Boolean(fixed.disable),
          required: Boolean(fixed.required),
        };
      });
      const otherFields = rawFields.filter(
        (f) => !defaultFixedFields.some((fixed) => fixed.name === f.name || fixed.label?.toLowerCase() === f.label?.toLowerCase())
      );
      setFormFields([...topFields, ...otherFields.map((f, idx) => {
        const isFieldNumeric = /^field\d+$/i.test(f?.name || "");
        const name = isFieldNumeric && f?.label
          ? f.label.toLowerCase().trim().replace(/[^a-z0-9_]+/g, "_").replace(/^_+|_+$/g, "")
          : f.name;
        return { id: f.id || `custom_${f.name || idx}`, ...f, name };
      })]);
      setOfferLetter({
        ...data,
        header_footer_mode: activeMode,
        access_header: data?.access_header != null ? Boolean(data?.access_header) : Boolean(data?.header || currentLetterHead?.letterhead_header),
        access_footer: data?.access_footer != null ? Boolean(data?.access_footer) : Boolean(data?.footer || currentLetterHead?.letterhead_footer),
        header: data?.header || currentLetterHead?.letterhead_header || "",
        footer: data?.footer || currentLetterHead?.letterhead_footer || "",
      });
    } else {
      setOfferLetter((prev) => ({
        ...prev,
        header_footer_mode: activeMode,
        access_header: Boolean(currentLetterHead?.letterhead_header),
        access_footer: Boolean(currentLetterHead?.letterhead_footer),
        header: currentLetterHead?.letterhead_header || "",
        footer: currentLetterHead?.letterhead_footer || "",
      }));
    }
    if (!data?.header_footer_mode && activeMode) {
      setData((prev) => ({ ...prev, header_footer_mode: activeMode }));
    }

    //eslint-disable-next-line
  }, []);


  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenu(true);
  };

  const addField = (params) => {
    const newField = {
      id: `field_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      name: `field${formFields.length + 1}`,
      label: "",
      type: params?.field?.type || "text",
      options: [],
      required: true,
      multiple: false,
    };
    setFormFields([...formFields, newField]);
    setMenu(false);
  };

  const removeField = (index, field) => {
    if (field?.disable) return;
    const updatedFields = [...formFields];
    const errorKeysToClear = [`label${index}`, `options${index}`];

    for (
      let optionIndex = 0;
      optionIndex < field.options?.length;
      optionIndex++
    ) {
      errorKeysToClear.push(`optionLabel${index}${optionIndex}`);
      errorKeysToClear.push(`optionValue${index}${optionIndex}`);
    }

    let temp = { ...errors };
    errorKeysToClear.forEach((key) => {
      temp[key] = "";
    });

    setErrors({
      ...temp,
    });
    updatedFields.splice(index, 1);
    setFormFields(updatedFields);
  };

  const createFieldObj = () => {
    const fieldObjects = formFields.map((field, index) => {
      const isFixed = Boolean(field?.disable) || defaultFixedFields.some((fixed) => fixed.name === field?.name);
      const name = isFixed
        ? field.name
        : (field.label ? field.label.toLowerCase().trim().replace(/[^a-z0-9_]+/g, "_").replace(/^_+|_+$/g, "") : field.name);
      const fieldObj = {
        name: name,
        type: field.type,
        label: field.label,
        sequence_no: index,
        required: field?.required,
        disable: field?.disable
      };
      return fieldObj;
    });
    return fieldObjects;
  };

  const validate = (fieldValues, formHeading, offerletter) => {
    let temp = { ...errors };
    if ("heading" in formHeading) {
      temp.heading =
        formHeading.heading === "" ? "Form Heading is required" : "";
    }

    fieldValues.forEach((field, index) => {
      if (field.label === "") {
        temp[`label${index}`] = `Prompt ${index + 1} is required`;
      } else {
        temp[`label${index}`] = "";
      }
    });

    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  const handleChange = (params) => {
    const updatedFields = [...formFields];
    if (params?.e?.target?.name === "field_type") {
      updatedFields[params?.index].type = params?.e.target.value;
      const errorKeysToClear = [
        `label${params?.index}`,
        `options${params?.index}`,
      ];
      for (
        let optionIndex = 0;
        optionIndex < params?.field.options.length;
        optionIndex++
      ) {
        errorKeysToClear.push(`optionLabel${params?.index}${optionIndex}`);
      }

      let temp = { ...errors };
      errorKeysToClear.forEach((key) => {
        temp[key] = "";
      });

      setErrors({
        ...temp,
      });
    }
    if (params?.e?.target?.name === "required") {
      updatedFields[params?.index].required = params?.e?.target?.checked;
    }
    if (params?.e?.target?.name === "field_label") {
      updatedFields[params?.index].label = params?.e.target.value;
      if (!updatedFields[params?.index]?.disable) {
        const slug = params?.e.target.value.toLowerCase().trim().replace(/[^a-z0-9_]+/g, "_").replace(/^_+|_+$/g, "");
        if (slug) {
          updatedFields[params?.index].name = slug;
        }
      }
    }
    setFormFields(updatedFields);
  };
  const onSubmit = async () => {
    if (validate(formFields, formHeading, offerletter)) {
      updateLoading(true);
      const dbObj = createFieldObj();
      let img_filename = "";
      let img_b64string = "";
      let old_image = "";
      const currentContent = data?.offer_letter_content || offerletter?.offer_letter_content || "";
      const parsedContent = parseOfferLetterContent(currentContent);
      const activeMode = data?.header_footer_mode || parsedContent?.header_footer_mode || offerletter?.header_footer_mode || "OUR_HEADER_FOOTER";

      if (data?.offer_letter_template_id) {
        UpdateOfferLetterTemplateHelper({
          ...offerletter,
          offer_letter_template_id: data?.offer_letter_template_id,
          offer_letter_template_name: formHeading?.heading,
          offer_letter_template_fields: JSON.stringify(dbObj),
          company_logo: img_filename,
          image_name: img_b64string,
          old_image: old_image,
          offer_letter_content: currentContent,
          is_letterhead: activeMode === "LETTERHEAD",
          is_configure_ctc: data?.is_configure_ctc !== false,
        }).then((res) => {
          updateLoading(false);
          if (res?.data?.statuscode === 200) {
            setFormHeading({ heading: "" });
            setFormFields([]);
            setFormComponents([]);
            setActiveStep(activeStep + 1);
            setData({
              ...(res?.data?.data?.[0] || data),
              is_letterhead: activeMode === "LETTERHEAD",
              header_footer_mode: activeMode,
              header: offerletter?.header || currentLetterHead?.letterhead_header || "",
              footer: offerletter?.footer || currentLetterHead?.letterhead_footer || "",
              access_header: offerletter?.access_header,
              access_footer: offerletter?.access_footer,
              offer_letter_content: res?.data?.data?.[0]?.offer_letter_content || currentContent,
              docBytes: data?.docBytes,
            });
          }
        }).catch(() => {
          updateLoading(false);
        });
      } else {
        AddOfferLetterTemplateHelper({
          ...offerletter,
          offer_letter_template_name: formHeading?.heading,
          offer_letter_template_fields: JSON.stringify(dbObj),
          company_logo: img_filename,
          image_name: img_b64string,
          offer_letter_content: currentContent,
          is_letterhead: activeMode === "LETTERHEAD",
          is_configure_ctc: data?.is_configure_ctc !== false,
        }).then((res) => {
          updateLoading(false);
          if (res?.data?.statuscode === 200) {
            setFormHeading({ heading: "" });
            setFormFields([]);
            setFormComponents([]);
            setActiveStep(activeStep + 1);
            setData({
              ...(res?.data?.data?.[0] || data),
              is_letterhead: activeMode === "LETTERHEAD",
              header_footer_mode: activeMode,
              header: offerletter?.header || currentLetterHead?.letterhead_header || "",
              footer: offerletter?.footer || currentLetterHead?.letterhead_footer || "",
              access_header: offerletter?.access_header,
              access_footer: offerletter?.access_footer,
              offer_letter_content: res?.data?.data?.[0]?.offer_letter_content || currentContent,
              docBytes: data?.docBytes,
            });
          }
        }).catch(() => {
          updateLoading(false);
        });
      }
    }
  };

  const parsedCurrent = parseOfferLetterContent(data?.offer_letter_content || offerletter?.offer_letter_content);
  const activeCaptionMode = data?.header_footer_mode || parsedCurrent?.header_footer_mode || offerletter?.header_footer_mode || "OUR_HEADER_FOOTER";

  return (
    <Box sx={{ maxHeight: "85vh", overflowY: "auto", pb: 2 }}>
      <Box>
        <Typography sx={{ mb: 1, textAlign: "center" }} variant="h6">
          {" "}
          Prompt Customization
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Grid container spacing={2} style={{ justifyContent: "center" }}>
            <Grid sx={{ width: "100%" }} item>
              <Card>
                <CardContent>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 0.8, mb: 1.5 }}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#64748b",
                        fontSize: "12px",
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      {activeCaptionMode === "LETTERHEAD"
                        ? "Format: Company Letterhead (PDF Background)"
                        : "Format: Configured Header & Footer (Default)"}
                    </Typography>
                    <Tooltip
                      title={
                        activeCaptionMode === "LETTERHEAD"
                          ? "This offer letter uses your official pre-uploaded letterhead PDF background. Margins are adjusted automatically."
                          : "This offer letter uses your organization's logo, header title, and footer text configured in settings."
                      }
                      arrow
                    >
                      <InfoOutlinedIcon sx={{ fontSize: 16, color: "#8b44ff", cursor: "pointer" }} />
                    </Tooltip>
                  </Box>
                  <TextField
                    label="Offer Letter Title"
                    size="small"
                    variant="standard"
                    margin="normal"
                    name="heading"
                    fullWidth
                    value={formHeading?.heading}
                    required={true}
                    sx={{ mb: 4 }}
                    inputProps={{ style: { fontSize: 23 } }}
                    InputLabelProps={{ style: { fontSize: 20 } }}
                    onChange={(e) =>
                      setFormHeading({ [e.target.name]: e.target.value })
                    }
                    {...(errors.heading && {
                      error: true,
                      helperText: errors.heading,
                    })}
                  />
                  <Box
                    style={{
                      backgroundColor: grey[100],
                      borderRadius: "10px",
                    }}
                  >
                    <Grid container spacing={2} direction={"row"} p={2}>
                      {formFields.map((field, index) => (
                        <Grid item xs={12} key={field.id || `field_${index}`}>
                          <Box display="flex" alignItems="center" mb={2}>
                            <TextField
                              label="Prompt"
                              value={field.label}
                              name="field_label"
                              size="small"
                              fullWidth
                              disabled={field.disable}
                              onChange={(e) => {
                                handleChange({ e, index });
                              }}
                              {...(errors[`label${index}`] && {
                                error: true,
                                helperText: errors[`label${index}`],
                              })}
                            />
                            {!field.disable && (
                              <Tooltip title="Remove Field">
                                <IconButton
                                  onClick={() => removeField(index, field)}
                                  size="small"
                                  color="error"
                                  aria-label="delete"
                                  mt={1}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                          {field.type !== "radio" && (
                            <Box sx={{ marginRight: "25px" }} mb={2}>{formComponents[index]}</Box>
                          )}
                        </Grid>
                      ))}
                    </Grid>
                    <Box sx={{ width: "100%", p: 2 }}>
                      <Tooltip title="Add New Prompt">
                        <IconButton
                          onClick={handleMenu}
                          className="mpl-primary-btn"
                        >
                          <Add fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        anchorEl={anchorEl}
                        open={menu}
                        onClose={() => setMenu(false)}
                        anchorOrigin={{
                          vertical: "center",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "center",
                          horizontal: "left",
                        }}
                        getContentAnchorEl={null}
                      >
                        <List
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            pt: 0,
                            pb: 0,
                          }}
                        >
                          <MenuItem
                            value="text"
                            name="field_type"
                            onClick={(e) => {
                              addField({ field: { type: "text" } });
                            }}
                          >
                            <TextFieldsIcon
                              color="primary"
                              fontSize="small"
                              sx={{ mr: 1 }}
                            />
                            Text
                          </MenuItem>
                          <MenuItem
                            value="date"
                            name="field_type"
                            onClick={(e) => {
                              addField({ field: { type: "date" } });
                            }}
                          >
                            <CalendarMonthIcon
                              color="primary"
                              fontSize="small"
                              sx={{ mr: 1 }}
                            />
                            Date
                          </MenuItem>
                        </List>
                      </Menu>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: "6px",
              padding: "0px 10px 4px 10px",
            }}
          >
            <Button
              variant="contained"
              className="mpl-primary-btn"
              onClick={() => setCurrentMode("grid")}
              disabled={loading}
            >
              Back
            </Button>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={data?.is_configure_ctc !== false}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setData((prev) => ({ ...prev, is_configure_ctc: checked }));
                    }}
                    color="primary"
                  />
                }
                label={
                  <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                    <span>Configure CTC</span>
                    <Tooltip
                      title="Enable to configure CTC and salary components for this template. If disabled, CTC configuration step will be skipped."
                      arrow
                      placement="top"
                    >
                      <InfoOutlinedIcon sx={{ fontSize: 16, color: "#64748b", cursor: "pointer" }} />
                    </Tooltip>
                  </Box>
                }
                sx={{ mr: 0 }}
              />
              <Button
                variant="contained"
                className="mpl-primary-btn"
                onClick={onSubmit}
                disabled={loading}
                startIcon={
                  loading ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : null
                }
              >
                Next
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Prompt;
